import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import WhyChooseSection from '../components/WhyChooseSection';
import FeaturesSection from '../components/FeaturesSection';
import EncryptedEmailSection from '../components/EncryptedEmailSection';
import Footer from '../components/Footer';
import ChatModal from '../components/ChatModal';

const HomePage = () => {
  const [isChatOpen, setIsChatOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Navbar onChatClick={() => setIsChatOpen(true)} />
      <HeroSection />
      <FeaturesSection />
      <EncryptedEmailSection />
      <WhyChooseSection />
      <Footer />
      <ChatModal isOpen={isChatOpen} onClose={() => setIsChatOpen(false)} />
    </div>
  );
};

export default HomePage;